<template>
  <!--
  <router-link class="memberbrief d-flex flex-column align-items-start" :to="" tag="div">
    <h4 class="mt-3">{{ this.member_data.name }}</h4>
    <p>{{ this.member_data.position }}</p>
  </router-link>
  -->
  <div class="memberbrief d-flex flex-column align-items-start">
    <h4 class="mt-3">{{ this.member_data.name }}</h4>
    <p>{{ this.member_data.position }}</p>
  </div>
</template>

<script>
import { getWagtailImage } from "@/api";

export default {
  name: "MemberBrief",
  data() {
    return {
      download_url: "",
      title: "",
      path: '/members/' + this.member_data.id,
      url: ''
    };
  },
  created() {
    getWagtailImage(this.member_data.photo).then(response => {
      const image = response.data;
      this.download_url = image.meta.download_url;
      this.title = image.title;
    });
    this.url = process.env.VUE_APP_API_URL
  },
  props:["member_data"]
};

</script>

<style lang="scss">
.memberbrief {
  h4 {
    font-weight: 500;
    font-size: 1.1em;
    color: $dark-color;
    margin-top: 0rem !important;
    margin-bottom: 0.2em;
  }
  p {
    font-size: 0.8em;
    line-height: 1.1em;
  }
}
</style>